module.exports = __webpack_public_path__ + "img/icon_heart_14.ae9c8a9b.svg";